/* 共通初期化 */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import $ from 'jquery'
import { isDev } from '@/js/utils/env'
import { getMockResponse, mockManager } from '@/js/api/mock'
//import ElementUI from 'element-ui'
//import locale from 'element-ui/lib/locale/lang/ja'
//import "@/assets/scss/element-variables.scss";
//import "element-ui/packages/theme-chalk/src/index"
import lang from "element-ui/lib/locale/lang/ja";
import locale from "element-ui/lib/locale";
import 'desvg';

window.addEventListener('load', () => {
  deSVG('img[inline]', true)
})

// region Vue
Vue.config.productionTip = false
//Vue.use(ElementUI, { locale })
locale.use(lang);
Vue.use(Vuex)
// endregion

// region axios
const ajaxAxiosOpts = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
}

let token = document.head.querySelector('meta[name="csrf-token"]')
if (token) {
  ajaxAxiosOpts.headers['X-CSRF-TOKEN'] = token.content
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

const ajax = axios.create(ajaxAxiosOpts)
if (isDev()) {
  ajax.interceptors.request.use(config => {
    const mockData = mockManager.findByConfig(config)
    if (mockData) {
      const mockError = new Error()
      mockError.mockData = mockData
      mockError.config = config
      return Promise.reject(mockError)
    }
    return config
  }, error => {
    return Promise.reject(error)
  })

  ajax.interceptors.response.use(response => response, error => {
    if (error.mockData) {
      return getMockResponse(error)
    }
    return Promise.reject(error)
  })
}
// endregion

// グローバル変数格納用
if (!window.APP) {
  window.APP = {}
}

window.APP.NODE_ENV = process.env.NODE_ENV

// 呼び出すごとにVueのグローバル設定するのを避けるためにグローバル領域におく
// ほかのファイルでは必ずwindow.Vueで呼び出す
/**
 *
 * @type {VueConstructor}
 */
window.Vue = Vue

/**
 *
 * @type {*|jQuery|HTMLElement}
 */
window.$ = $
/**
 *
 * @type {{Store: typeof Store; install: typeof install}}
 */
window.Vuex = Vuex
/**
 *
 * @type {AxiosStatic}
 */
window.axios = axios
/**
 *
 * @type {AxiosInstance}
 */
window.ajax = ajax
/**
 *
 * @type {{getStore, add, findMock}}
 */
window.mockManager = mockManager
// endregion

/**
 * @export {{Vue: VueConstructor, Vuex: {Store: typeof Store; install: typeof install}, axios: axios, ajax: ajax}}
 */
export {
  Vue, Vuex, axios, ajax, $
}
